<template>
  <div style="padding-bottom:44px">
    <van-field label="序列号" v-model="jlct82_Step2.serialNumber">
      <template #right-icon>
        <van-tag type="warning">{{jieMa}}</van-tag>
      </template>
    </van-field>
    <van-cell title="版本号确认">
      <template #right-icon>
        <van-checkbox v-model="jlct82_Step2.banBenHaoQueRen" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="3.3V检测">
      <template #right-icon>
        <van-checkbox v-model="jlct82_Step2.sanDianSanCeLiang" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="蓝牙连接">
      <template #right-icon>
        <van-checkbox v-model="jlct82_Step2.lanYaLianJie" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="开机检测">
      <template #right-icon>
        <van-checkbox v-model="jlct82_Step2.kaiJiJianCe" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="关机检测">
      <template #right-icon>
        <van-checkbox v-model="jlct82_Step2.guanJiJianCe" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="指示灯检测">
      <template #right-icon>
        <van-checkbox v-model="jlct82_Step2.zhiShiDengJianCe" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="充电检测">
      <template #right-icon>
        <van-checkbox v-model="jlct82_Step2.chongDianJianCe" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="通道1检测">
      <template #right-icon>
        <van-checkbox v-model="jlct82_Step2.tongDao1JianCe" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="通道2检测">
      <template #right-icon>
        <van-checkbox v-model="jlct82_Step2.tongDao2JianCe" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-field label="备注" v-model="jlct82_Step2.remark"> </van-field>
    <el-button type="primary" class="footer1" icon="el-icon-view" circle @click="handlePicClick"></el-button>
    <div class="footer">
      <van-button type="info" v-show="$parent.hasPower_Step2" round block :disabled="$parent.jlct82_SignNumber.status!=0" @click="handleSave">保存</van-button>
      <van-button type="danger" v-if="$parent.jlct82_SignNumber.status==2" round block @click="$parent.cancel_void_SignNumber()">取消作废</van-button>
      <van-button type="danger" v-else-if="$parent.jlct82_SignNumber.status!=1" round block @click="$parent.void_SignNumber()">作废</van-button>

    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  props: ["signNumber"],
  data() {
    return {
      jlct82_Step2: {},
      jieMa: "",
    };
  },
  methods: {
    handlePicClick() {
      ImagePreview(["./images/JLCT82_Produce.png"]);
    },
    getJLCT82_Step2() {
      let that = this;
      that.axios
        .post("/JLCT82/GetJLCT82_Step2", { onlyText: that.signNumber })
        .then(function (response) {
          that.jlct82_Step2 = response.data.data;
        });
    },
    handleSave() {
      let that = this;
      that.axios
        .all([that.save_JLCT82_Step2(), that.registerSerialNumber()])
        .then(
          that.axios.spread(function (response1, response2) {
            that.jlct82_Step2 = response1.data.data;
            if (response1.data.code == 201) {
              that.$notify({ type: "warning", message: response1.data.msg });
            } else if (response2.data.code == 201) {
              that.$notify({ type: "warning", message: response2.data.msg });
            } else {
              that.$notify({ type: "success", message: response1.data.msg });
            }
            if (response2.data.code == 101) {
              that.jieMa = response2.data.msg;
            }
          })
        );
    },
    save_JLCT82_Step2() {
      let that = this;
      return that.axios.post("JLCT82/UpdateJLCT82_Step2", that.jlct82_Step2);
    },
    registerSerialNumber() {
      let that = this;
      return that.axios.post("Base_Device/Register", {
        productName: "静力触探",
        productId: 1113,
        serialNumber: that.jlct82_Step2.serialNumber,
        deviceType: "JLCT82",
        companyName: "",
        ifPrint: false,
      });
    },
  },
  mounted() {
    let that = this;
    that.getJLCT82_Step2();
  },
};
</script>

<style scoped>
.footer {
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
}
.footer1 {
  position: fixed;
  left: 10px;
  bottom: 50px;
}
</style>